module.exports = __webpack_public_path__ + "fonts/regular.ff4508c6.woff";